
class EmployeeConceptCell extends UITableViewCell
{
    private titleTextField:MUITextField = null;
    private keyTextField:MUITextField = null;
    private ledgerAccountDropdown:MUIButton = null;
    private isEditableSwitch:MUISwitchButton = null;
    private expressionTextField:MUITextField = null;

    awakeFromHTML(){
        super.awakeFromHTML();

        this.titleTextField = MUIOutlet(this, "title-tf", "MUITextField");
        this.keyTextField = MUIOutlet(this, "key-tf", "MUITextField");
        this.ledgerAccountDropdown = MUIOutlet(this, "ledger-account-dd", "MUIButton");
        this.isEditableSwitch = MUIOutlet(this, "is-editable-sw", "MUISwitchButton");
        this.isEditableSwitch.setOnChangeValue(this, function(this:EmployeeConceptCell, control:MUISwitchButton, on:boolean){
            this._concept.isEditable = on;
            this.updateUI();
        });
        this.expressionTextField = MUIOutlet(this, "expression-tf", "MUITextField");
        this.expressionTextField.setOnChangeText(this, function(this:EmployeeConceptCell, control:MUITextField, value:string){
            this._concept.expression = value.trim().length > 0 ? value.trim() : null;            
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }  
    
    private _concept:EmployeeCompensationConcept = null;
    set item(item:EmployeeCompensationConcept){
        this._concept = item;
        this.titleTextField.text = item.title;
        this.keyTextField.text = item.key;
        this.isEditableSwitch.on = item.isEditable;
        this.expressionTextField.text = item.expression;
        this.updateUI();
    }

    private updateUI(){
        this.expressionTextField.enabled = !this._concept.isEditable;
    }
}